import { render, staticRenderFns } from "./CounsumableModal.vue?vue&type=template&id=e8c1dbfa&scoped=true"
import script from "./CounsumableModal.vue?vue&type=script&lang=js"
export * from "./CounsumableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c1dbfa",
  null
  
)

export default component.exports